import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import Seo, { breadcrumbLd } from "../components/Seo";

export default function Artists() {
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/artists");
      setArtists(data);
    })();
  }, []);

  return (
    <div data-testid="artists-page" className="px-6 md:px-12 lg:px-24 py-16 md:py-24">
      <Seo
        title="Artists — Contemporary African Masters in Residence"
        description="Meet the contemporary African artists in residence at AfricaArtMasters. Painters, sculptors, mixed-media practitioners and photographers working across the continent and its diaspora."
        path="/artists"
        jsonLd={breadcrumbLd([
          { name: "Home", path: "/" },
          { name: "Artists", path: "/artists" },
        ])}
      />
      <p className="label-eyebrow text-[#555]">— The Roster</p>
      <h1 className="font-serif-display text-5xl md:text-7xl tracking-tighter leading-none font-light mt-4">
        Masters in residence
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mt-16">
        {artists.map((artist, i) => (
          <Link
            to={`/artist/${artist.id}`}
            key={artist.id}
            data-testid={`artist-list-${artist.id}`}
            className="block group"
          >
            <div className="hover-zoom-wrap aspect-[4/5] bg-[#F2EDE5]">
              <img
                src={artist.avatar_url || "https://static.prod-images.emergentagent.com/jobs/2cf555d8-2b2e-4a65-8a76-f17be07c4f4a/images/d11b06ed5c6c920763ec229eb9d9f1c7ad885e95f977d086b28da211c4d8e0ef.png"}
                alt={`${artist.name}, contemporary African artist${artist.country ? ` from ${artist.country}` : ""}`}
                className="hover-zoom w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700"
              />
            </div>
            <div className="mt-4">
              <p className="label-eyebrow text-[#555]">N° {String(i + 1).padStart(2, "0")}</p>
              <h3 className="font-serif-display text-3xl mt-1">{artist.name}</h3>
              <p className="text-sm text-[#555] mt-1">{artist.country} · {artist.artwork_count} works</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
